
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import styles from '../styles.js';

class MobileCheckButton extends Component {
    static propTypes = {
        filter: PropTypes.object.isRequired,
        filterGroup: PropTypes.object.isRequired,
        filterGroupCollection: PropTypes.object.isRequired,
        handleFilterChange: PropTypes.func.isRequired
    }

    render() {
        const {
            filter,
            filterGroup,
            filterGroupCollection,
            handleFilterChange
        } = this.props;
        return (
            <span>
                <button
                    className={
                        filter.data.value ?
                            css(styles.button_checked) :
                            css(styles.button)
                    }
                    id={`checkbox-filter_${filter.filterId}-${filterGroup.id}-${filterGroupCollection.id}`}
                    data-filter-id={filter.filterId}
                    data-filter-group-id={filterGroup.id}
                    data-filter-group-collection-id={filterGroupCollection.id}
                    data-input-type={filterGroup.inputType}
                    data-value={filter.data.value}
                    onClick={handleFilterChange}
                >
                    {filter.title}
                </button>
            </span>
        );
    }
}

export default MobileCheckButton;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/SearchContent/MobileFilterBar/MobileCheckButton/MobileCheckButton.jsx